export const fileUploadConstants = {
  Max_File_Size_Bytes: 15 * 1024 * 1024,
  Required_Upload_File_Headers: {
    Vendor: ['vendor_id', 'vendor_name', 'country', 'vendor_type'],
    SKU: [
      'primary_id',
      'secondary_id',
      'level_1',
      'level_2',
      'level_3',
      'description',
      'primary_vendor_id',
      'hts_code',
      'product_type',
    ],
    PO: [
      'year',
      'month',
      'primary_id',
      'vendor_id',
      'cost',
      'po_volume',
      'sales_quantity',
      'currency',
    ],
  },
  Supported_File_Extensions: ['xls', 'xlsx', 'zip'],
  Error_Messages: {
    File_Size_Exceeded: 'The file size exceeds the limit. Please ensure it is less than 15MB.',
    INCORRECT_FILE_FORMAT: 'The file format is incorrect. Please make sure it is an .xls or .xlsx',
    Unsupported_File_Format: 'Unsupported file format. Only .xls and .xlsx files are allowed.',
    Invalid_File_Structure: 'Invalid file structure. Please upload file in GTO-provided template.',
    Unexpected_Sheet_Names:
      'The uploaded file contains unexpected sheet names. Please upload file in GTO-provided template.',
    Password_Protected:
      'The file is password protected. Please upload file in GTO-provided template.',
    Read_Error: 'Error reading the file. Please upload file in GTO-provided template.',
    File_Incorrect: 'The file format is incorrect. Please make sure it is an .xls or .xlsx.',
  },
}

export const poMonths = [
  { label: 'January', value: 1 },
  { label: 'February', value: 2 },
  { label: 'March', value: 3 },
  { label: 'April', value: 4 },
  { label: 'May', value: 5 },
  { label: 'June', value: 6 },
  { label: 'July', value: 7 },
  { label: 'August', value: 8 },
  { label: 'September', value: 9 },
  { label: 'October', value: 10 },
  { label: 'November', value: 11 },
  { label: 'December', value: 12 },
]

export const poCurrency = ['USD', 'EUR', 'GBP', 'CAD']

export const productType = ['Finished Product', 'Raw Material']

export const vendorType = ['Manufacturer', 'Distributor']

// tooltip content for additional context modal
export const additionalContextModalTooltip = {
  vendorType: {
    text: 'Help AI classify vendor roles more accurately. Sample prompt:',
    details: [
      'Specify the type of vendor to help categorize their business role e.g., "manufacturer", "distributor", "logistics provider"',
    ],
  },
  productType: {
    text: 'For accurate enrichment and distinction between raw materials and finished goods, provide additional context for AI, such as:',
    details: [
      'Product Descriptions with “coil”, “sheet”, “resin”, “pellet”; phrases like “used in machining” or “input for...” usually classify as Raw Materials.',
      'Product Descriptions with “bracket”, “housing”, “assembly”; phrases like “ready to install” or “coated/processed parts” usually classify as Finished Goods.',
    ],
  },
  htsCode: {
    text: 'Add context to improve HTS classification. You can provide additional context as follows:',
    details: [
      'Industry (e.g., Automotive Tier-1)',
      'Product Category (e.g., Wiring Harness)',
      'Geographic Market (e.g., US, EU)',
      'Use Case (e.g., for engine mounting)',
    ],
  },
}

export const filterConfig = {
  vendorDetails: [
    { key: 'vendorId', label: 'Vendor ID', isMulti: true, dependsOn: [] },
    { key: 'vendorName', label: 'Vendor Name', isMulti: true, dependsOn: ['vendorId'] },
    { key: 'vendorType', label: 'Vendor Type', isMulti: true, dependsOn: [] },
    { key: 'country', label: 'Country', isMulti: true, dependsOn: [] },
  ],
  skuProduct: [
    { key: 'l1', label: 'L1', isMulti: true, dependsOn: [] },
    { key: 'productType', label: 'Product Type', isMulti: true, dependsOn: [] },
    { key: 'l2', label: 'L2', isMulti: true, dependsOn: ['l1'] },
    { key: 'htsCode', label: 'HTS Code', isMulti: true, dependsOn: [] },
    { key: 'l3', label: 'L3', isMulti: true, dependsOn: ['l2'] },
    { key: 'variant', label: 'Variant', isMulti: true, dependsOn: [] },
  ],
  uploadDetails: [
    { key: 'uploadedFrom', label: 'From', type: 'date', groupHeading: 'Upload Date Range' },
    { key: 'uploadedTo', label: 'To', type: 'date' },
    { key: 'uploadedBy', label: 'Uploaded By', isMulti: true, dependsOn: [] },
  ],
  modelDetails: [
    { key: 'l1', label: 'L1', isMulti: true, dependsOn: [] },
    { key: 'country', label: 'Country of Origin', isMulti: true, dependsOn: [] },
    { key: 'l2', label: 'L2', isMulti: true, dependsOn: ['l1'] },
    { key: 'modelType', label: 'Model Type', isMulti: true, dependsOn: [] },
    { key: 'l3', label: 'L3', isMulti: true, dependsOn: ['l2'] },
  ],
  creatorDetails: [{ key: 'createdBy', label: 'createdBy', isMulti: true, dependsOn: [] }],
}

export const initialSelectedFilters = {
  vendorDetails: {
    vendorId: [],
    vendorName: [],
    vendorType: [],
    country: [],
  },
  skuProduct: {
    l1: [],
    l2: [],
    l3: [],
    variant: [],
    productType: [],
    htsCode: [],
  },
  uploadDetails: {
    uploadedFrom: null,
    uploadedTo: null,
    uploadedBy: [],
  },
  ltmSpends: [0, 0],
  confidenceScores: [],
  po_eligible: null,
  ifa_shortlisting: null,
}

export const detailsKeys = {
  vendorKeys: ['vendorId', 'vendorName', 'vendorType', 'country'],
  skuKeys: ['l1', 'l2', 'l3', 'variant', 'productType', 'htsCode'],
  uploadKeys: ['uploadedFrom', 'uploadedTo', 'uploadedBy'],
}

export const compareValues = (valA, valB) => {
  if (valA === valB) return true

  if (Array.isArray(valA) && Array.isArray(valB)) {
    if (valA.length !== valB.length) return false
    for (let i = 0; i < valA.length; i++) {
      if (valA[i] !== valB[i]) return false
    }
    return true
  }
  return false
}
